import theme from "@src/theme"
export default theme
